<template>
  <v-row no-gutters>
    <v-col>
      <span
        ref="editable"
        :contenteditable="editable"
        :class="editable ? 'text-cursor' : ''"
        :style="{ '--placeholder': `'${placeholder || ''}'` }"
        @input="$emit('input', $event.target.innerText)"
      ></span>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
    },
    placeholder: String,
    // editable: {
    //   type: Boolean,
    //   default: false,
    // },
    styles: {
      type: String,
    },
    isEdit: {
      type: Boolean,
    },
  },
  computed: {
    editable() {
      return this.isEdit;
    },
  },
  mounted() {
    this.$refs.editable.innerText = this.value ?? "";
  },
};
</script>
<style lang="scss" scoped>
[contenteditable] {
  outline: 0 solid transparent;
  display: block;
}

span[contenteditable]:empty:focus::before,
span[contenteditable]:empty::before {
  content: var(--placeholder);
  opacity: 0.3;
}

.div1 {
  overflow-x: scroll;
  white-space: nowrap;
}

.hideScrollbar::-webkit-scrollbar {
  display: none;
}

.hideScrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
